/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { PasswordInput } from '@/components/PasswordInput'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { toast } from 'sonner'
import { useNavigate } from 'react-router-dom'
import Loading from '@/components/Loading'
import { usePlatformLoginMutation } from '@/hooks/usePlatformAuth'

const schema = z.object({
  email: z.email({ message: 'Email invalide' }),
  password: z.string().min(8, 'Min 8 caractères'),
})
type Values = z.infer<typeof schema>

export default function PlatformLoginPage() {
  const form = useForm<Values>({
    resolver: zodResolver(schema),
    defaultValues: { email: '', password: '' },
  })

  const { mutateAsync, isPending } = usePlatformLoginMutation()
  const navigate = useNavigate()

  const onSubmit = async (v: Values) => {
    try {
      await mutateAsync({
        email: v.email.trim().toLowerCase(),
        password: v.password,
      })
      toast.success('Connexion platform OK')
      navigate('/platform', { replace: true })
    } catch (e: any) {
      toast.error('Connexion impossible', {
        description:
          e?.response?.data?.message ?? 'Email ou mot de passe incorrect',
      })
    }
  }

  return (
    <div className='flex flex-row items-center justify-center h-[100vh] bg-gradient-to-br from-[hsl(0,0%,100%)] via-[hsl(140,13%,91%)] to-[hsl(144,80%,73%)]'>
      <Card className='w-[520px] rounded-xl shadow-2xl'>
        <CardHeader>
          <div className='flex flex-row items-center gap-3'>
            <img
              src='/logo_mogesapp_light.png'
              alt='MOGESAPP'
              className='h-8 w-8 dark:hidden'
              loading='eager'
            />
            {/* Mode sombre */}
            <img
              src='/logo_mogesapp_dark.png'
              alt='MOGESAPP'
              className='h-8 w-8 hidden dark:block'
              loading='eager'
            />
            <h1 className='font-bold text-primary text-2xl'>MOGESAPP</h1>
            <h1 className='text-2xl font-semibold'>Platform Admin</h1>
          </div>

          <p className='text-sm text-muted-foreground'>
            Connexion espace super-admin/support/billing
          </p>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className='space-y-4'>
              <FormField
                control={form.control}
                name='email'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Email</FormLabel>
                    <FormControl>
                      <Input placeholder='admin@mogesapp.com' {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name='password'
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Mot de passe</FormLabel>
                    <FormControl>
                      <PasswordInput placeholder='••••••••' {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              {isPending ? (
                <Loading />
              ) : (
                <Button type='submit'>Se connecter</Button>
              )}
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  )
}
